export default __webpack_public_path__ + "static/media/ελτα_ΗΛ.2a1bdf86.png";